import { connect, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { authActions } from '../../reducers/auth.reducer';
var HamburgerLink = function HamburgerLink(_ref) {
  var url = _ref.url,
    externalUrl = _ref.externalUrl,
    children = _ref.children,
    action = _ref.action,
    active = _ref.active,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    logoutAction = _ref.logoutAction,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var userPermissions = useSelector(function (s) {
    var _s$auth, _s$auth$user;
    return ((_s$auth = s.auth) === null || _s$auth === void 0 ? void 0 : (_s$auth$user = _s$auth.user) === null || _s$auth$user === void 0 ? void 0 : _s$auth$user.permissions) || [];
  });
  var handleOnClick = function handleOnClick() {
    if (onClick) onClick();
    if (action) {
      if (action === 'logout') {
        logoutAction();
      }
    }
  };
  if (permission && !userPermissions.find(function (x) {
    return x.key === permission && x.value === true;
  })) return null;
  if (!url) return /*#__PURE__*/React.createElement("div", {
    className: "hamburger__link ".concat(className, " ").concat(active ? 'hamburger__link--active' : ''),
    onClick: handleOnClick
  }, children);
  return /*#__PURE__*/React.createElement("div", {
    className: "hamburger__link ".concat(className, " ").concat(active ? 'hamburger__link--active' : ''),
    onClick: handleOnClick
  }, externalUrl ? /*#__PURE__*/React.createElement("a", {
    href: externalUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children) : /*#__PURE__*/React.createElement(NavLink, {
    to: url
  }, children));
};
var mdtp = {
  logoutAction: authActions.logout
};
export default connect(null, mdtp)(HamburgerLink);